import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/movies";

export default function HotMovies() {
  const hotList = [...movies].sort((a, b) => b.hot - a.hot).slice(0, 8);

  return (
    <section className="mx-auto w-full max-w-screen-xl px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门电影推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600">高分口碑与观影热度兼备，闭眼入不踩雷</p>
        </div>
        <Link
          to="/category?sort=hot"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex"
        >
          查看全部
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </Link>
      </div>

      {hotList.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
          暂无推荐电影
        </p>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {hotList.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </section>
  );
}